<template>
  <div class="po" v-if="isShow.isPOShow">
    <div class="test-clock">
      <span class="test-num">{{num}}/5</span>
      <span class="test-desc">答题进度</span>
    </div>
    <div class="test-bb">
      <div class="test-blank">第{{gotData.num}}题</div>
      <div :class="isResolved ? 'test-question-hide' : 'test-question'" >{{gotData.que}}</div>
    </div>
    <div class="test-desk">
      <div class="opt-wp">
        <div class="opt-wp1">
          <div class="option opta" :class="isResolvedA ? (gotData.a.isRight == 1 ? 'r' : 'w') : ''" @click="handleSelect(`${gotData.a.isRight}`, 'a')">
            <div class="text">{{gotData.a.txt}}</div>
            <div class="judge"></div>
          </div>
        </div>
        <div class="opt-wp2">
          <div class="option optb" :class="isResolvedB ? (gotData.b.isRight == 1 ? 'r' : 'w') : ''" @click="handleSelect(`${gotData.b.isRight}`, 'b')">
            <div class="text">{{gotData.b.txt}}</div>
            <div class="judge"></div>
          </div>
        </div>
        <div class="opt-wp3">
          <div class="option opta" :class="isResolvedC ? (gotData.c.isRight == 1 ? 'r' : 'w') : ''" @click="handleSelect(`${gotData.c.isRight}`, 'c')">
            <div class="text">{{gotData.c.txt}}</div>
            <div class="judge"></div>
          </div>
        </div>
        <div class="opt-wp4">
          <div class="option optd" :class="isResolvedD ? (gotData.d.isRight == 1 ? 'r' : 'w') : ''" @click="handleSelect(`${gotData.d.isRight}`, 'd')">
            <div class="text">{{gotData.d.txt}}</div>
            <div class="judge"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pop-wp" v-show="isPopShow">
      <div class="pop-camera1">
        <div class="pop-shadow"></div>
      </div>
      <div class="pop-pos pop-pos-dis">
        <img :src="fnPos" alt="" class="pop-dis-img">
        <p class="pop-text">本次答对题目<span class="pop-num">{{collected}}</span>道</p>
        <div class="pop-result">
          <div class="pop-coin">+{{100*collected}}</div>
        </div>
        <div class="btn-group">
          <div class="pop-btn" @click="replay">再玩一次</div>
          <div class="pop-btn" @click="showNext">查看海报</div>
        </div>
      </div>
      <div class="pop-camera2"></div>
    </div>
    <div class="img-wp">
      <img src="./img/save1.png" class="img1" alt="">
      <img src="./img/save2.png" class="img2" alt="">
      <img src="./img/save3.png" class="img3" alt="">
      <img src="./img/save4.png" class="img4" alt="">
      <img src="./img/save5.png" class="img5" alt="">
      <img src="./img/qr.png" class="qr" alt="">
    </div>
  </div>
</template>

<script>
import { questions } from './questions.js';

export default {
  name: 'Loading',
  props: {
    isShow: Object
  },
  data() {
    return {
      num: 1,
      collected: 0,
      isResolvedA: false,
      isResolvedB: false,
      isResolvedC: false,
      isResolvedD: false,
      isResolved: false,
      isPopShow: false,
    }
  },
  methods: {
    showNext() {
      this.genPoster()
      setTimeout(() => {
        this.$emit('nextPage', 'isPTShow')        
      }, 300)
    },
    replay() {
      window.location.reload()
    },
    genPoster() {
      const num = this.collected === 0 ? 1 : this.collected
      const img = document.querySelector(`.img${num}`)
      const qr = document.querySelector('.qr')
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      canvas.width = 700
      canvas.height = 1259

      ctx.drawImage(img, 0, 0, img.width, img.height)
      ctx.drawImage(qr, 500, 1050, 185, 185)
      const src = canvas.toDataURL()
      this.$emit('sendResult', src)
    },
    reset() {
      this.isResolvedA = false
      this.isResolvedB = false
      this.isResolvedC = false
      this.isResolvedD = false
      this.isResolved = false
    },
    resolveIt(para) {
      switch (para) {
        case 'a':
          this.isResolvedA = true
          this.isResolved = true
          break;
        case 'b':
          this.isResolvedB = true
          this.isResolved = true
          break;
        case 'c':
          this.isResolvedC = true
          this.isResolved = true
          break;
        case 'd':
          this.isResolvedD = true
          this.isResolved = true
          break;
        default:
          this.reset()
          break;
      }
    },
    handleSelect(para, p2) {
      this.resolveIt(p2)
      if (para == 1) {
        this.collected += 1
      }
      setTimeout(() => {
        this.reset()
        this.num === 5 ? this.num : this.num++
      }, 200);
      if (this.num === 5) {
        this.isPopShow = true
      }
    }
  },
  computed: {
    gotData() {
      return questions[this.num]
    },
    fnPos() {
      switch (this.collected) {
        case 0:
        case 1:
          return require('./img/pop-pos1.png')
        case 2:
          return require('./img/pop-pos2.png')
        case 3:
          return require('./img/pop-pos3.png')
        case 4:
          return require('./img/pop-pos4.png')
        case 5:
          return require('./img/pop-pos5.png')
        default:
          return require('./img/pop-pos1.png')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 测试页面 */
.bg(@url) {
  background-image: url(@url);
  background-size: cover;
  background-repeat: no-repeat;
}

.po {
  width: 46.875/2rem /* 750/16 */;
  height: 100vh;
  .bg('./img/test-bg.jpg');
}
.test-clock {
  position: relative;
  margin: 0 auto;
  top: 2vh;
  width: 44.375/2rem /* 710/16 */;
  height: 8.0625/2rem /* 129/16 */;
  .bg('./img/test-clock.png');
}
.test-num {
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: inline-block;
  height: 2rem;
  color: #d62b44;
  font-size: 1.2rem;
}
.test-desc {
  position: absolute;
  top: 0.5rem;
  left: 4rem;
  display: inline-block;
  height: 1.6rem;
  color: #235c7f;
  font-size: 1.2rem;
}
.test-bb {
  position: relative;
  top: 6vh;
  margin: 0 auto;
  width: 44.4375/2rem /* 711/16 */;
  height: 35.5/2rem /* 568/16 */;
  background-image: url(./img/test-blackboard.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.test-blank {
  position: absolute;
  top: 2.5rem;
  left: 50%;
  margin-left: -28.75/4rem /* 460/16 */;
  width: 28.75/2rem /* 460/16 */;
  height: 6.25/2rem /* 100/16 */;
  background-size: cover;
  background-image: url(./img/test-num.png);
  background-repeat: no-repeat;
  color: #333;
  font-size: 1.5rem;
  line-height: 6.25/2rem;
  text-align: center;
}
.test-question {
  position: absolute;
  top: 14.375/2rem /* 230/16 */;
  width: 100%;
  box-sizing: border-box;
  padding: 0 2rem;
  text-align: center;
  font-size: 1.2rem;
  color: white;
  transition: opacity .3s ease-in;
}
.test-question-hide {
  opacity: 0;
}
.test-desk {
  position: absolute;
  bottom: 0;
  width: 46.875/2rem /* 750/16 */;
  height: 34.5625/2rem /* 553/16 */;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(./img/test-desk.png);
}
.opt-wp {
  margin-top: 1rem;
  padding: 0 1.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  transition: opacity .3s ease-in .3s;
}
.option {
  position: relative;
  width: 19/2rem /* 304/16 */;
  height: 8.5625/2rem /* 137/16 */;
  margin: 0.4rem 0;
  padding: 0 0.5rem;
  box-sizing: border-box;
  background-image: url(./img/test-opt-bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  line-height: 8.5625/2rem /* 137/16 */;
  font-size: 1.2rem;
  text-align: center;
}
.w .judge {
  position: absolute;
  right: 0.8rem;
  bottom: 0.8rem;
  width: 5.375/2rem /* 86/16 */;
  height: 4.5625/2rem /* 73/16 */;
  background-image: url(./img/test-cross.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.r .judge {
  position: absolute;
  right: 0.8rem;
  bottom: 0.8rem;
  width: 5.375/2rem /* 86/16 */;
  height: 3.8125/2rem /* 61/16 */;
  background-image: url(./img/test-tick.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.opt-wp1 {
  opacity: 1;
  transform-origin: 0 100%;
  transform: rotate(-6deg);
}
.opt-wp2 {
  transform-origin: 100% 100%;
  transform: rotate(5deg);
}
.opt-wp3 {
  transform-origin: 0 100%;
  transform: rotate(-1deg);
}
.opt-wp4 {
  transform-origin: 100% 0;
  transform: rotate(3deg);
}

// pop
.pop-wp {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .6);
}
.pop-camera1 {
  position: absolute;
  left: 50%;
  margin-left: -43.0625/4rem /* 689/16 */;
  width: 43.0625/2rem /* 689/16 */;
  height: 20.3125/2rem /* 325/16 */;
  .bg('./img/pop-camera1.png');
  z-index: 5;
}
.pop-camera2 {
  position: absolute;
  left: 50%;
  top: 10rem;
  margin-left: -43.0625/4rem /* 689/16 */;
  width: 43.0625/2rem /* 689/16 */;
  height: 4/2rem /* 64/16 */;
  .bg('./img/pop-camera2.png');
}
.pop-shadow {
  position: absolute;
  left: 50%;
  bottom: -1rem;
  margin-left: -36.6875/4rem /* 587/16 */;
  width: 36.6875/2rem /* 587/16 */;
  height: 2.25/2rem /* 36/16 */;
  background-image: url(./img/pop-shadow.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.pop-pos {
  position: absolute;
  top: 10rem;
  left: 50%;
  margin-left: -17.5/2rem /* 280/16 */;;
  width: 17.5rem /* 280/16 */;
  padding: .625rem /* 10/16 */;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 3;
  img {
    width: 32.5625/2rem /* 521/16 */;
    height: 38.75/2rem /* 620/16 */;
  }
}
.pop-text {
  margin-top: 1rem;
  font-size: 1rem;
  text-align: center;
  line-height: 1.2;
}
.pop-result {
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pop-coin {
  padding-left: 1.875rem /* 30/16 */;
  background-image: url(./img/pop-coin.png);
  background-repeat: no-repeat;
  background-size: auto 100%;
  color: #e50e45;
  font-weight: bold;
  font-size: 1.2rem;
}
.btn-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pop-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 14.8125/2rem /* 237/16 */;
  height: 5.1875/2rem /* 83/16 */;
  background-color: #d62c44;
  color: white;
  font-weight: bold;
  letter-spacing: 2px;
  transition: transform .3s ease, opacity .2s ease;
  &:active {
    opacity: .8;
    transform: scale(.9);
  }
}
.img-wp {
  display: none;
}
.poster {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 31.25rem /* 500/16 */;
  opacity: 0;
  z-index: 10;
  transform: translateZ(0);
}

.popin {
  animation: popin .3s ease-out forwards;
}

@keyframes popin {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.popbounce {
  animation: popbounce .2s forwards;
}

@keyframes popbounce {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pop-pos-dis {
  animation: display 1s .2s ease-out both;
}

@keyframes display {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

</style>